import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react';

function nameEntryHandlers(onValueChange?: (value: string) => void) {
	return {
		onChange: (event: { currentTarget: HTMLInputElement | HTMLTextAreaElement }) => {
			onValueChange?.(event.currentTarget.value);
		},
		onCompositionEnd: (event: { currentTarget: HTMLInputElement | HTMLTextAreaElement }) => {
			onValueChange?.(event.currentTarget.value);
		},
	};
}

export function NameInput({
	onValueChange,
	...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'onBlur' | 'type'> & { onValueChange?: (value: string) => void }) {
	const handlers = nameEntryHandlers(onValueChange);
	return <input {...props} type="text" autoCapitalize="none" {...handlers} />;
}

export function NameTextarea({
	onValueChange,
	...props
}: Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange' | 'onBlur'> & { onValueChange?: (value: string) => void }) {
	const handlers = nameEntryHandlers(onValueChange);
	return <textarea {...props} autoCapitalize="none" {...handlers} />;
}
